/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-11 16:05:53
 * @LastEditTime: 2024-05-31 11:47:29
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\userMaage\forget\index.tsx
 * @Description: 忘记密码页面
 */

import { CommmonGet, CommmonPost } from "@/util/network/api";
import { CheckPhone } from "@/util/public";
import { Form, message } from "antd";
import { LgButton, LgInput, lgAlert } from "lancoo-web-ui";
import { useEffect, useState } from "react";
import { service } from "../data";
import NameIcon from '../images/姓名.svg';
import SecureIcon from '../images/安全.svg';
import PasswordIcon from '../images/密码.svg';
import PhoneIcon from '../images/手机.svg';
import { useSelector } from "react-redux";
import { selectUserId } from "../../../store/reducers/userInfo";

function Forget(props: any) {
  const {
    form,
    onLogin,
    setIsloading,
    onUpPassword,
    setCode
  } = props;

  const userId = useSelector(selectUserId);

  const [countdown, setCountdown] = useState<number>(60); // 倒计时秒数
  const [timingShow, setTimingShow] = useState<boolean>(false);

  const submit = () => {
    form.validateFields().then((values) => {
      setIsloading(true);
      CommmonPost(service.preResetPasswordByPhone, values).then((res: any) => {
        // message.success("修改密码成功");
        onUpPassword(values.phone);
        setCode(res.data)
      }).catch(error => {
        (error?.msg || error?.message) && message.error(error?.msg || error?.message);
      }).finally(() => {
        setIsloading(false);
      });
    }).catch(error => {
      console.log(error);
    })
  }

  useEffect(() => {
    const formData = form.getFieldsValue();
    form.setFieldsValue({
      ...formData,
      phone: '',
      code: '',
    });
  }, []);

  /**
    * @description: 获取忘记密码手机验证码
    * @param {*} void
    * @return {*}
    */
  const getRegisterCode = (): void => {
    // 禁用获取验证码按钮
    const formData = form.getFieldsValue();
    if (formData.phone) {
      if (!CheckPhone(formData.phone)) {
        message.warning('手机号格式有误', 2);
        return;
      }
      setIsloading(true);
      CommmonGet(service.checkPhone, {
        phone: formData.phone
      }).then((res: any) => {
        if (res?.data?.status == 4) {
          CommmonGet(service.sendLoginSmsCode, {
            phone: formData.phone,
            type: '2'
          }).then(res => {
            message.success("发送成功");
            startCountdown();
          }).finally(() => {
            setIsloading(false);
          });
        } else {
          message.warning("该手机号未注册");
        }
      }).finally(() => {
        setIsloading(false);
      });


    } else {
      message.warning('请输入手机号', 2);
    }
  };

  /**
    * @description: 倒计时
    * @return {*}
    */
  const startCountdown = () => {
    setTimingShow(true)
    let timer = setInterval(() => {
      setCountdown(prevCountdown => prevCountdown - 1);
    }, 1000);

    setTimeout(() => {
      setTimingShow(false)
      clearInterval(timer);
      setCountdown(60); // 重置倒计时秒数为60
    }, countdown * 1000);
  };

  return (
    <>
      <Form.Item
        style={{ position: 'relative', marginBottom: 0 }}
        className='form_icon'
      >
        <div className='form_icon_div' style={{ background: `url(${PhoneIcon}) no-repeat center` }} />
        <Form.Item
          name="phone"
          rules={[
            { required: true, message: '请输入手机号' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || CheckPhone(value)) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('手机号格式有误'));
              },
            }),
          ]}
          style={{ marginBottom: 16 }}
        >
          <LgInput
            bigWidth
            input={{ placeholder: "请输入注册时绑定的手机号" }}
            size='oversized'
            style={{ height: 48 }}
          />
        </Form.Item>
      </Form.Item>
      <Form.Item
        style={{ position: 'relative', marginBottom: 0 }}
        className='form_icon form_iconMa'
      >
        <div className='form_icon_div' style={{ background: `url(${SecureIcon}) no-repeat center` }} />
        <Form.Item
          name="code"
          rules={[{ required: true, message: '请输入验证码!' }]}
          style={{ marginBottom: 16 }}
        >
          <LgInput
            bigWidth
            input={{ placeholder: "请输入验证码" }}
            size='oversized'
            // onKeyDown={handleKeyDown}
            style={{ height: 48 }}
          />
        </Form.Item>
        <span style={{
          position: 'absolute',
          top: 0,
          right: '16px',
          lineHeight: '48px'
        }}>
          {timingShow ?
            <div
              className='onclik_cls'
              style={{
                color: '#999999',
                cursor: 'default'
              }}
            >
              ({countdown}秒后重新获取)
            </div> :
            <div
              onClick={getRegisterCode}
              className='onclik_cls'
            >
              获取验证码
            </div>
          }
        </span>
      </Form.Item>

      <Form.Item style={{ marginBottom: 10 }}>
        <LgButton
          onClick={submit}
          backgroundType='opacification'
          type='info'
          size='super'
          style={{ justifyContent: 'center', width: 360 }}
        >
          确认
        </LgButton>
      </Form.Item>
      {!userId && <div>
        {/* <span style={{ color: '#999999' }}>手机不能使用？请</span> */}
        {/* <span className='onclik_cls' onClick={onUpPhone}>换绑手机</span> */}
        <span className='onclik_cls' onClick={onLogin}>前往登录</span>
      </div>}
    </>
  )
}

export default Forget
